import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './evaluation.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { Evaluation } from "model/dealer/evaluation.model";

export interface EvaluationDetailsProps extends DetailsStateAndDispatchProps<Evaluation>,
  RouteComponentProps, StateProps, DispatchProps {
}
const EvaluationDetails: FC<EvaluationDetailsProps> = (props) => {
  return (
    <DetailsPage<Evaluation>
      title={'详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<Evaluation>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ evaluation }: RootState) => ({
  entity: evaluation.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(EvaluationDetails);
